(ns ui.components.input.simple-text
  (:require
   [common.util :as cu]
   [ui.util :as uu]
   [oops.core :as oops]
   [reagent.core :as r]))

(defn view
  [{:keys [_ref _class _custom-class value _auto-focus? _variant _disabled? _read-only? _full-width? _on-change _on-focus _on-blur _on-key-down]}]
  (let [local-state (r/atom {:temp-value value})]
    (fn [{:keys [ref dom-id class _custom-class placeholder input-mode value auto-focus? variant disabled? read-only? transparent? full-width? on-change on-focus on-blur on-key-down label]}]
      (let [{:keys [selection-start selection-end]} @local-state]
        [:input
         (merge {:ref         (fn [input-ref]
                                (when input-ref
                                  (swap! local-state assoc :ref input-ref)
                                  (when (:focused? @local-state)
                                    (oops/ocall input-ref "setSelectionRange" selection-start selection-end))
                                  (when-not (:initialized? @local-state)
                                    (swap! local-state assoc :initialized? true)
                                    (when auto-focus?
                                      (oops/ocall input-ref "focus"))
                                    (when (fn? ref)
                                      (ref input-ref)))))
                 :class-name  (uu/cm "peer mb-0 px-3 rounded text-input-light-text"
                                     "disabled:text-disabled-regular-text text-sm"
                                     "placeholder:text-input-light-text-paler"
                                     "focus:outline-none focus:ring-0"
                                     (when-not (cu/blank-value? label)
                                       "")
                                     (if transparent?
                                       "bg-transparent disabled:bg-transparent"
                                       "bg-input-light disabled:bg-disabled-regular")
                                     (if (not= variant :borderless)
                                       "py-2 border border-solid border-input-light-border-paler hover:border-input-light-border focus:border-input-light-border"
                                       "py-2 border-none focus:border-transparent ")
                                     (when full-width?
                                       "w-full")
                                     (when-not (cu/blank-value? value)
                                       "value")
                                     (when read-only? "")                                           ;;TODO Hanna add read-only styling
                                     class)
                 :id          dom-id
                 :input-mode  input-mode
                 :placeholder (or placeholder "")
                 :value       (or (:temp-value @local-state)
                                  value
                                  "")
                 :on-focus    (fn [_e]
                                (swap! local-state assoc :temp-value value
                                       :focused? true)
                                (when-let [input-ref (:ref @local-state)]
                                  (let [selection-start (or selection-start
                                                            (count (str (or (:temp-value @local-state)))))
                                        selection-end (or selection-end selection-start)]
                                    (.setSelectionRange input-ref selection-start selection-end)))
                                (when (fn? on-focus)
                                  (on-focus)))
                 :on-blur     (fn [e]
                                (swap! local-state assoc :temp-value nil)
                                (when (fn? on-blur)
                                  (on-blur (->> e
                                                .-target
                                                .-value))))
                 :on-key-down (fn [e]
                                (when (fn? on-key-down)
                                  (on-key-down e)))
                 :on-change   (fn [e]
                                (let [value (->> e .-target .-value)]
                                  (swap! local-state assoc
                                         :selection-start (-> e .-target .-selectionStart)
                                         :selection-end (-> e .-target .-selectionEnd)
                                         :temp-value value)
                                  (deref local-state)
                                  (cond (fn? on-change)
                                        (on-change value))))}
                (when disabled?
                  {:disabled true})
                (when read-only?
                  {:read-only true}))]))))
